module.exports = __webpack_public_path__ + "static/img/version3.2d2be86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version3.png
// module id = Rsin
// module chunks = 1